export default __webpack_public_path__ + "static/media/dark.836eca39.png";